// @ts-nocheck
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-children-prop */
import React, { useMemo, forwardRef } from 'react'
import {
  Box,
  Heading,
} from '@chakra-ui/react'
import { Formik, Form, useFormikContext, FormikProps } from 'formik'

import { BlueFormType } from './form-types'
import { FormCopySection, FormQuestionSection } from './components'

interface BlueFormProps extends FormikProps {
  title: string;
  form: BlueFormType;
  initialValues?: object;
  isDisabled?: boolean;
}

export const BlueForm: React.FC<BlueFormProps> = forwardRef(({ title, form, initialValues, isDisabled = false, children, ...rest }, ref) => {

  const initialFormValues = useMemo(() => initialValues || form.reduce((existing, section) => {
    if (section.type === 'question') {
      existing[section.id] = null
    }
    return existing
  }, {}), [initialValues, form])

  return (
    <Box>
      <Box>
        <Heading as="h1">{title}</Heading>
      </Box>
      <Box>
        <Formik
          initialValues={initialFormValues}
          ref={ref}
          {...rest}
        >
          {() => (
            <Form>
              <Box>
                {form.map(section => {
                  if (section.type === 'question') {
                    return <FormQuestionSection section={section} key={section.id} isDisabled={isDisabled} />
                  } else if (section.type === 'copy') {
                    return <FormCopySection section={section} key={section.id} />
                  }
                })}
              </Box>
              <Box>
                {children}
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  )
})
